// BannerSection.tsx — drop this between YouTubeSection and AboutSection in your homepage

export default function BannerSection() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 ">
    <section className="relative overflow-hidden py-0">
      {/* Top fade from dark background above */}
      <div className="absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-[#080808] to-transparent z-10 pointer-events-none" />
      
      <div className="relative">
        <img
          src='/images/Spiritual bhakti.jpg'
          alt="Spiritual Bhakti — Crafting Music & Digital Content Since 1995"
          className="w-full object-cover object-center h-auto p-2"
          
        //   style={{ maxHeight: '280px' }}
        />
        {/* Overlay to blend with dark theme */}
        {/* <div className="absolute inset-0 bg-black/30" /> */}
      </div>

      {/* Bottom fade into next section */}
      <div className="absolute bottom-0 left-0 right-0 h-12 bg-gradient-to-t from-[#0d0d0d] to-transparent z-10 pointer-events-none" />
    </section>
    </div>
  );
}